/**
 * * Configuração para o componente de input.
 */
export class InputConfig {
    constructor (
        /**
         * * Tipo do input.
         */
        public type: InputType,
        /**
         * * Identificador do input.
         */
        public id?: string,
        /**
         * * Name do input.
         */
        public name?: string,
        /**
         * * Valor do input.
         */
        public value?: string,
        /**
         * * Placeholder para o input.
         */
        public placeholder?: string,
        /**
         * * Desabilitado.
         */
        public disabled?: boolean,
        /**
         * * Readonly.
         */
        public readonly?: boolean,
        /**
         * * Obrigatório.
         */
        public required?: boolean,
        // text
        /**
         * * Tamanho para o input de texto.
         */
        public size?: string,
        // number
        /**
         * * Valor mínimo para o input de número.
         */
        public min?: number,
        /**
         * * Valor máximo para o input de número.
         */
        public max?: number,
        /**
         * * Valor do Step para o input de número.
         */
        public step?: number,
        // textarea
        /**
         * * Número de Colunas para o input de Área de Texto.
         */
        public cols?: number,
        /**
         * * Número de Linhas para o input de Área de Texto.
         */
        public rows?: number,
        /**
         * * Tamanho mínimo dos inputs de Texto.
         */
        public minLength?: number,

        /**
         * * Tamanho Máximo dos inputs de Texto.
         */
        public maxLength?: number,

    ) {}
}

/**
 * * Tipos de Input.
 */
export enum InputType {
    text = 'text',
    number = 'number',
    textarea = 'textarea',
    password = 'password',
    email = 'email'
}
